// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"a52ec2e0","371":"fa5a8df2","377":"772d5280","655":"e7b8e023"}[chunkId] + ".chunk.js";
};